import { useTranslation } from 'react-i18next'
import { FormikProvider } from 'formik'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@mui/material'

import { Close } from '@mui/icons-material'
import { DialogsEnum } from '@/enums'
import useDialog from '@/hooks/ui/use-dialog.hook'

import { usePlayerCardForm } from '@/views/player-card/hooks'
import InputFormikField from '@/views/components/input-formik-field/index.component'
import InputFormikCheckbox from '@/views/components/input-formik-checkbox/index.component'

import {
  LanguagePersonalInfo,
  MobileNumberPersonalInfo,
  GenderPersonalInfo,
  CountryPersonalInfo,
} from './'

export const DialogPersonalInfoForm = () => {
  const { t } = useTranslation()
  const { dialog, handleCloseDialog } = useDialog()
  const { formikPlayer, handleSubmit } = usePlayerCardForm()

  return (
    <Dialog
      open={dialog.open && dialog.id === DialogsEnum.DIALOG_EDIT_PLAYER_DATA}
      aria-labelledby="dialog-title"
      fullWidth
      sx={{
        '& .MuiDialog-paperFullWidth': {
          width: '600px',
          maxWidth: '100%',
        },
      }}
    >
      <DialogTitle id="dialog-title">
        <Box mb={1} display="flex" justifyContent="space-between" width="100%">
          <Typography fontWeight={700} variant="h5" sx={{ mt: 0.5, pl: 1 }}>
            {t('playerCard.personalInformation')}
          </Typography>
          <Box display="flex" alignItems="center">
            <IconButton onClick={handleCloseDialog}>
              <Close />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <FormikProvider value={formikPlayer}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <InputFormikField label={t('labels.email')} name="email" />
            </Grid>
            <MobileNumberPersonalInfo />
            <Grid item xs={12}>
              <InputFormikField
                label={t('labels.birthday')}
                name="dateOfBirth"
                isDatePicker
              />
            </Grid>
            <Grid item xs={6}>
              <LanguagePersonalInfo />
            </Grid>
            <Grid item xs={6}>
              <GenderPersonalInfo />
            </Grid>
            <Grid item xs={6}>
              <CountryPersonalInfo />
            </Grid>
            <Grid item xs={6}>
              <InputFormikField label={t('labels.state')} name="state" />
            </Grid>
            <Grid item xs={6}>
              <InputFormikField label={t('labels.city')} name="city" />
            </Grid>
            <Grid item xs={6}>
              <InputFormikField label={t('labels.zipCode')} name="zipCode" />
            </Grid>
            <Grid item xs={12}>
              <InputFormikField label={t('labels.address')} name="address" />
            </Grid>
            <Grid item xs={6}>
              <InputFormikField
                label={t('labels.currency')}
                name="currency"
                disabled
              />
            </Grid>
            <Grid item xs={6}>
              <InputFormikField
                label={t('labels.registrationIp')}
                name="registrationIp"
                disabled
              />
            </Grid>
            <Grid item xs={6}>
              <InputFormikField
                label={t('labels.regDate')}
                name="registrationDate"
                disabled
                isDatePicker
              />
            </Grid>
          </Grid>
          <Box sx={{ marginTop: 2 }}>
            <Typography fontWeight={700} gutterBottom>
              {t('labels.marketingConsent')}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <InputFormikCheckbox
                label={t('labels.emailOptIn')}
                name="emailOptIn"
              />
              <InputFormikCheckbox
                label={t('labels.smsOptIn')}
                name="smsOptIn"
              />
            </Box>
          </Box>
        </FormikProvider>
        <DialogActions sx={{ padding: '10px 0px' }}>
          <Button onClick={handleCloseDialog} className="red">
            {t('labels.cancel')}
          </Button>
          <Button
            disabled={!(formikPlayer.isValid && formikPlayer.dirty)}
            variant="contained"
            onClick={() => handleSubmit()}
          >
            {t('labels.update')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}
